import './App.css';
import MainPage from './components/Pages/MainPage/MainPage';

function App() {
  return (
    <div>
      <MainPage></MainPage>
    </div>
  );
}

export default App;
